export default __webpack_public_path__ + "static/media/nightmareB4XmasCropped.f556a55f.jpg";